module.exports = __webpack_public_path__ + "static/img/login_activitybg.f3b8ad8f.png";